import { Pagination } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useDoctorsData } from "../../../providers/doctorsData";

export const ListNav = () => {
  const { pages, page, setPage } = useDoctorsData();

  const [searchParams, setSearchParams] = useSearchParams();

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
    searchParams.set("page", value.toString());
    setSearchParams(searchParams);
  };

  if(pages <= 1){
    return <></>;
  }

  return (
    <nav className="mt-3 pagination">
      <Pagination
        color="primary"
        count={Number(pages)}
        page={Number(page)}
        onChange={handleChange}
      />
    </nav>
  );
};
